export default {
  configs: (state) => state.configs,
  loading: (state) => state.loading,
  editingConfig: (state) => state.editingConfig,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
